import { render, staticRenderFns } from "./CompanySelectorMenu.vue?vue&type=template&id=a8275944&"
import script from "./CompanySelectorMenu.vue?vue&type=script&lang=js&"
export * from "./CompanySelectorMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports